import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlarisLanguageService } from '@campaign-portal/components-library';
import { TranslateModule } from '@ngx-translate/core';
import { TuiLegendItem, TuiRingChart } from '@taiga-ui/addon-charts';

@Component({
	selector: 'app-campaign-statistics-chart',
	templateUrl: './campaign-statistics-chart.component.html',
	styleUrls: ['./campaign-statistics-chart.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslateModule, TuiRingChart, TuiLegendItem],
	standalone: true,
})
export class CampaignStatisticsChartComponent {
	@Input() value: number[] = [1, 2];
	@Input() labels: string[] = ['Test 1', 'Test 2'];
	@Input() totalRecipients = 0;

	activeItemIndex = Number.NaN;

	constructor(private readonly langService: AlarisLanguageService) {}

	get amount(): number {
		return Number.isNaN(this.activeItemIndex) ? this.totalRecipients : this.value[this.activeItemIndex];
	}

	get label(): string {
		return Number.isNaN(this.activeItemIndex)
			? this.langService.translate('gl.total')
			: this.labels[this.activeItemIndex];
	}

	isItemActive(index: number): boolean {
		return this.activeItemIndex === index;
	}

	onHover(index: number, hovered: MouseEvent): void {
		this.activeItemIndex = hovered ? index : 0;
	}

	getColor(index: number): string {
		return `var(--tui-chart-categorical-0${index})`;
	}

	makeNaN(): void {
		this.activeItemIndex = Number.NaN;
	}
}
